import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import { CircularProgress, Backdrop, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

export const PrivateRoute = ({ component: Component, roles, ...rest }) => {
  const classes = useStyles();
  const token = localStorage.getItem("token:data");
  const { profile } = useSelector((state) => state.users);

  return (
    <Route
      {...rest}
      render={(props) => {
        // No token = not authenticated
        if (!token) {
          return <Redirect to={{ pathname: "/", state: { from: props.location } }} />;
        }

        // Token exists but profile not loaded yet
        if (!profile) {
          return (
            <Backdrop className={classes.backdrop} open={true}>
              <CircularProgress color="inherit" />
            </Backdrop>
          );
        }

        // Check if roles are required
        if (roles && roles.length > 0) {
          const hasRequiredRole = profile.role?.some((role) =>
            roles.includes(role.name)
          );

          if (!hasRequiredRole) {
            return <Redirect to={{ pathname: "/dashboard", state: { from: props.location } }} />;
          }
        }

        // All checks passed, render component
        return <Component {...props} />;
      }}
    />
  );
};